import React from 'react'

import {
  CategorySelection,
  LocationSelection,
  LocationSelectionButton,
  ProjectResultsContainer,
  Search
} from 'discover'

export class Detail extends React.Component {
  render() {
    return (
      <div>
        <div className='container container-filter-bar'>
          <div className='row'>
            <div className='col-md-24 filter-bar m-b-md'>
              <span className='projects-count'>
                <strong>{ this.props.projectCount }</strong> { I18n.t('discover.categories.index.filter_bar_parts.projects') }
                <span className='hidden-md hidden-lg'> { I18n.t('discover.categories.index.filter_bar_parts.found') }</span>
              </span>
              <div className='selection-wrapper selects-category'>
                <span className='selection-label'>{ I18n.t('discover.categories.index.filter_bar_parts.for') }</span>
                <CategorySelection
                  categories={ this.props.categories }
                  categoryChanged={ this.props.categoryChanged }
                  categoryId={ this.props.categoryId }
                />
              </div>
              <div className='selection-wrapper selects-location'>
                <span className='selection-label'>{ I18n.t('discover.categories.index.filter_bar_parts.in') }</span>
                <LocationSelection
                  buttonClass={ LocationSelectionButton }
                  bounds={ this.props.bounds }
                  boundsChanged={ this.props.boundsChanged }
                  locations={ this.props.locations }
                />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-24 filter-bar'>
              <div className='search-wrapper detail-search-wrapper'>
                <span className='selection-label'>{ I18n.t('discover.categories.index.filter_bar_parts.with') }</span>
                <Search
                  searchQueryChanged={ this.props.searchQueryChanged }
                  searchQuery={ this.props.searchQuery }
                />
              </div>
            </div>
          </div>
        </div>

        <SeoText text={this.props.category && this.props.category.seoText1}
                 columnClass='col-md-20 col-md-offset-2 m-t-md'/>

        <div className='container container-project-results'>
          <ProjectResultsContainer
            apiBaseUrl={ this.props.apiBaseUrl }
            categoryId={ this.props.categoryId }
            bounds={ this.props.bounds }
            searchQuery={ this.props.searchQuery }
            setProjectCount={ this.props.setProjectCount }
            gtmList={ this.props.gtmList }
          />
        </div>

        <SeoText text={this.props.category && this.props.category.seoText2}
                 columnClass='col-md-16 col-md-offset-4 m-t-md'/>
      </div>
    )
  }
}

const SeoText = ({text, columnClass}) => {
  if (!text) return null

  return <div className='container'>
    <div className='row'>
      <div className={columnClass}>
        {text}
      </div>
    </div>
  </div>
}
